import gsap from 'gsap';

$('body').on('initScripts pageTransitionComplete', function() {
    const $masthead = $('header.masthead'),
        $menuItems = $masthead.find('.masthead__nav .menu > .menu-item'),
        $menuToggle = $masthead.find('.masthead__menu-toggle'),
        $mastheadButtons = $masthead.find('.masthead__btns'),
        classToToggle = 'masthead--small';

    let animDuration = 0.5,
        stickyThreshold = 0;

    if (!!prefersReducedMotion) {
        animDuration = 0;
    }

    if ($masthead.length) {
        stickyThreshold = $masthead.offset().top + ($masthead.height() * 0.5);

        $(window).on('resize', function () {
            stickyThreshold = $masthead.offset().top + ($masthead.height() * 0.5);
            stickyMasthead();
        });

        window.addEventListener('scroll', function () {
            stickyMasthead();
        });

        stickyMasthead();
    }

    function hideMenuItems () {
        if ($menuItems.length < 1 || viewport().width < 992) return;

        gsap.to($menuItems, {
            yPercent: -25,
            opacity: 0,
            visibility: 'hidden',
            duration: animDuration,
            ease: 'power2.inOut',
            stagger: 0.05
        });
    }

    function showMenuItems () {
        if ($menuItems.length < 1 || viewport().width < 992) return;

        gsap.to($menuItems, {
            yPercent: 0,
            opacity: 1,
            visibility: 'visible',
            duration: animDuration,
            ease: 'power2.inOut',
            stagger: {
                each: 0.05,
                from: 'end'
            }
        });
    }

    function showMenuToggle () {
        if ($menuToggle.length < 1) return;

        if (viewport().width > 991) {
            gsap.to($menuToggle, {
                opacity: 1,
                visibility: 'visible',
                duration: animDuration,
                ease: 'power2.inOut',
            });

            gsap.to($mastheadButtons, {
                width: $mastheadButtons.width() + parseInt($mastheadButtons.css('column-gap')) + $menuToggle.outerWidth(),
                duration: animDuration,
                ease: 'power2.inOut',
            });
        } else {
            gsap.set($menuToggle, { clearProps: 'all' });
            gsap.set($mastheadButtons, { clearProps: 'all' });
        }
    }

    function hideMenuToggle () {
        if ($menuToggle.length < 1) return;

        if (viewport().width > 991) {
            gsap.to($menuToggle, {
                opacity: 0,
                visibility: 'hidden',
                duration: animDuration,
                ease: 'power2.inOut',
            });

            gsap.to($mastheadButtons, {
                width: 'auto',
                duration: animDuration,
                ease: 'power2.inOut',
            });
        } else {
            gsap.set($menuToggle, { clearProps: 'all' });
            gsap.set($mastheadButtons, { clearProps: 'all' });
        }
    }

    function stickyMasthead () {
        let scrolledDistance = window.scrollY;

        if (scrolledDistance > stickyThreshold) {
            if (!$masthead.hasClass(classToToggle)) {
                $masthead.addClass(classToToggle);
                hideMenuItems();
                showMenuToggle();
            }
        } else {
            if ($masthead.hasClass(classToToggle)) {
                hideMenuToggle();
                showMenuItems();
                $masthead.removeClass(classToToggle);
            }
        }
    }
});
